import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <code>src/App.js</code> This is my first change
        </p>
        <a
          className="App-link"
          href="https://yahoo.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {process.env.REACT_APP_MSG}  -  {process.env.REACT_APP_GITHUB_REF}
        </a>
      </header>
    </div>
  );
}

export default App;
